//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { DropdownMenu } from '@components/primitives/dropdown-menu/DropdownMenu';
import { DropboxTrackingIds } from '@content-drawer/dropbox/dropboxConstants';
import { DropboxFile } from '@content-drawer/dropbox/dropboxModels';
import { useDropboxChooser } from '@content-drawer/dropbox/useDropboxChooser';

interface ContentImportOptionsDropdownProps {
  children: React.ReactNode;
  handleOnDropboxImport: (files: DropboxFile[]) => void;
  handleOnUpload: () => void;
}

export const ContentImportOptionsDropdown = ({
  children,
  handleOnDropboxImport,
  handleOnUpload,
}: ContentImportOptionsDropdownProps) => {
  const { chooseFromDropbox } = useDropboxChooser(handleOnDropboxImport);

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>{children}</DropdownMenu.Trigger>
      <DropdownMenu.Content align='start'>
        <DropdownMenu.Item onSelect={handleOnUpload}>
          Upload Media
        </DropdownMenu.Item>
        <DropdownMenu.Item
          onSelect={chooseFromDropbox}
          trackingId={DropboxTrackingIds.IMPORT_FROM_DROPBOX}
        >
          Import from Dropbox
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
